<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.energy.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/energy"><span>{{$t('tlt.energy.list')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/energy/edit"><span>{{$t('tlt.energy.add')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('energy')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('energy')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("lbl.basic.code") }}:</label>
                                <input class="form-control form-control-sm" v-model="enyCode" type="text" >
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("lbl.basic.name") }}:</label>
                                <input class="form-control form-control-sm" v-model="enyName" type="text" >
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg"></span>{{ $t("tlt.energy.matDesc") }}:</label>
                                <input class="form-control form-control-sm" v-model="matDesc" type="text" >
                            </div> -->
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("lbl.basic.type") }}:</label>
                                <select class="form-control form-control-sm" 
                                
                                @click.native.stop @change="disableHierarchy" v-model="enyType">
                                        <option value="S">{{ $t("lbl.energy.type.solidty") }}</option>
                                        <option value="G">{{ $t("lbl.energy.type.gas") }}</option>
                                        <option value="F">{{ $t("lbl.energy.type.fluid") }}</option>
                                </select>
                            </div>
                            </div>                          
                            <div class="form-group col-md-3">
                                <label class="control-label">{{ $t("lbl.material.unit") }}</label>
                                <input class="form-control form-control-sm" v-model="enyUnit" type="text">
                        </div> 
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState } from "vuex";
// import {fields}  from "@/model/Material";
import {fields}  from "@/model/master/Energy";

const { mapFields } = createHelpers({
  getterType: 'energy/getField',
  mutationType: 'energy/updateField',
});
export default {
  data () {
    return {
      energyTypeDisabled: true,
      energyNameDisabled: true,
      matTypeDisable:true,
      typeDisabled:true
    }
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
        energyTypeCBO: state => state.energy.energyTypeCBO,
        energyNameCBO: state => state.energy.energyNamerCBO,
    })
  },
  mounted(){
     //this.MMFCheckState('location'); 
     this.typeDisabled = (this.$store.state.energy.crudState == 'edit');
      if( !this.typeDisabled){
          this.disableHierarchy();
      }
  },
  methods: {
    ...mapActions("energy", ["loadenergyType", "selectParentMaterial"]),
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
    disableHierarchy(){
        this.matTypeDisabled= true;
        this.energyNameDisabled = true;
        this.typeDisabled=true;

        this.$store.commit("energy/setMaterialNameCBO", []);
        this.$store.commit("energy/setMaterialTypeCBO", []);

        var enty1 = JSON.parse(JSON.stringify(this.$store.state.energy.entity));
        enty1.energyType = "";
        enty1.energyName = "";


        this.$store.commit("energy/setEntity", enty1);

        switch (this.$store.state.energy.entity.matType) {
            case 'N':
                this.energyTypeDisabled= false;    
            break;
            // case 'N':
            //     this.energyTypeDisabled= false;
            //    c
            // break;
        }
        this.$store.dispatch('energy/loadMaterialByType', {type: 'T', idMaterial : 0} );
    }
  }
};
</script>